<template>
  <v-row align="center" justify="center">
  <v-container fluid class="pa-0">
    <div class="main-hero pa-0">
    <v-snackbar
      v-model="showMessages"
      vertical
      top
      right
    >
      <p class="mb-0">Hay errores en el formulario:</p>
      <p
        v-for="(msg, index) in messages"
        :key="index"
        class="mb-0 d-block"
        >{{(index + 1) + ': ' + msg}}</p>
    </v-snackbar>
    <v-row align="center" justify="center" class="text-center" style="margin-top: 80px;">
      <v-col cols="10" sm="6" md="4">
        <v-card class="elevation-24 rounded-xl background-login pa-5">
          <h3 class="text-center mb-3" style="color: #FFF;">Regístra tu cuenta</h3>
        <div class="mx-auto" style="max-width: 500px;" v-if="!registerOK">
<!--           <v-img
            :src="require('../../assets/logo-iduam.svg')"
            class="my-3"
            contain
            height="200"
          /> -->
          <v-form
            ref="form"
            class="custom-form-registro"
            v-model="valid"
          >
            <div class="text-center">
              <v-text-field
                v-model="userInfo.name"
                :rules="required"
                label="Nombre"
                required
                type="text"
                background-color="white"
                outlined
                dense
                class="inputForm"
                filled
                color="primary"
              ></v-text-field>
              <v-text-field
                v-model="userInfo.rut"
						    :rules="rut"
                label="RUT"
                required
						    @keyup="(rut) => {formatRut(userInfo.rut)}"
                color="primary"
                background-color="white"
                outlined
                dense
                class="inputForm"
                filled
              ></v-text-field>
              <v-text-field
                v-model="userInfo.email"
                :rules="isEmailValid"
                label="Email"
                required
                @change="(email) => {isEmail(email)}"
                color="primary"
                background-color="white"
                outlined
                dense
                class="inputForm"
                filled
              ></v-text-field>
              <v-text-field
                v-model="userInfo.password"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="required"
                :type="showPass ? 'text' : 'password'"
                name="input-10-1"
                label="Contraseña"
                hint="Mínimo 8 caracteres"
                @click:append="showPass = !showPass"
                color="primary"
                background-color="white"
                outlined
                dense
                class="inputForm"
                filled
              ></v-text-field>
              <v-text-field
                v-model="userInfo.password_confirmation"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="required"
                :type="showPass ? 'text' : 'password'"
                name="input-10-1"
                label="Confirma Contraseña"
                hint="Mínimo 8 caracteres"
                @click:append="showPass = !showPass"
                color="primary"
                background-color="white"
                outlined
                dense
                class="inputForm"
                filled
              ></v-text-field>
              <v-btn style="background: white; font-weight: 600;" variant="text" block @click="() => registro()">Registrar</v-btn>
              <p style="color: #FFF;" class="mt-4 mb-0">¿Ya tienes cuenta? <router-link to="/login"  style="color: #FFF;">Ingresa</router-link></p>
            </div>
          </v-form>
        </div>

        <div v-else style="margin-top: 32px;">
          <h2 class="text-center white--text">Se ha enviado un correo para verificar correo electrónico</h2>
          <v-icon style="display:flex; font-size: 65px;" class="text-center white--text" large color="green">mdi-check-circle</v-icon>
    </div>
        </v-card>
      </v-col>
    </v-row>
    </div>
  </v-container>
  </v-row>
</template>

<script>
  import {register} from '../../helpers/api/user'
import {validate, format} from 'rut.js';


  export default {
    name: 'Register',
    data: () => ({
      count: 3,
      menu: false,
      showMessages: false,
      messages: null,
      showPass: false,
      registerOK: false,
      paises: [],
      regiones: [],
      comunas: [],
      userInfo: {
        name: '',
        rut: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      valid: false,
      validRut: false,
      required: [
        v => !!v || 'Este campo es obligatorio'
      ],
      rut: [
        v => (!!v || 'Este campo es obligatorio') && (validate(v) || 'Rut no válido')
      ],
      requiredPhone: [
        v => !!v || 'Este campo es obligatorio',
        v => ( !!v && /^\d+$/.test(v) ) || 'Ingrese sólo números'
      ],
      isEmailValid: [
        //eslint-disable-next-line
        v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Formato incorrecto'
      ],
      items: [{text: 'Femenino', value: 2}, {text: 'Masculino', value: 1}],
    }),
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    methods: {
      isEmail(email){
        //eslint-disable-next-line
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
      },
      formatRut(rut) {
        this.userInfo.rut = format(rut)  
        this.validRut = validate(this.userInfo.rut)
    },
      async registro(){
        if(this.$refs.form.validate()){
          const self = this
          const data = this.userInfo
          data.company_id = this.$store.state.company_id
          data.area_id = this.$store.state.area_id
          register(data)
            .then(async function () {
              self.registerOK = true
            })
            .catch(function (error) {
              self.messages = Object.values(error.response.data.errors)
              self.showMessages = true
            });
        }
      },
    }
  }
</script>
<style type="text/css" media="screen">
  .main-hero {
		background-size: cover;
		min-height: 600px;
  }

  .text-field-custom  {
    color: #f2f3f5;
  }
.custom-placeholer-color input::placeholder {
  color: #f2f3f5 !important;
  opacity: 1;
}

.custom-label-color .v-label {
  color: #f2f3f5 !important;
  opacity: 1;
}
.custom-label-color.v-input--error {
  color: #f2f3f5!important; /* Cor vermelha */
  caret-color: #f2f3f5!important; /* Cor do cursor vermelha */
}

  .google-btn {
  display: flex;
  justify-content: space-between;
  background: #f2f3f5;
  max-width: 500px;
  margin: 0 auto;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  border: #0000 solid 1px;
}

@media (max-width: 450px) {
  .google-btn {
    justify-content: center;
    gap: 8px;
    width: 100%;
  }
}

.google-btn img {
  background: #f2f3f5;
}

.loader {
  height: 15px;
  aspect-ratio: 5;
  -webkit-mask: linear-gradient(90deg#007BED ,#FFF 20% 80%,#007BED);
  background: radial-gradient(closest-side at 37.5% 50%,#FFF 94%,#007BED) 0/calc(80%/3) 100%;
  animation: l48 .75s infinite linear;
}
@keyframes l48 {
  100% {background-position: 36.36%}
}
.background-login {
  background: linear-gradient(140deg,#3587c2 0%, #003153 100%) !important;

}

.inputForm {
  border-radius: 10px !important;
}
</style>